import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {AppBar, Toolbar, Container, Button} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import UserPill from './UserPill';
import UcsbHdaeLockup from './ucsb-hdae-lockup-white.svg';
import AuthorizedContent from './AuthorizedContent';
import UserContext from './UserContext';
import {useContext} from 'react';
import {useIsAdmin} from '../../hooks/useIsAdmin';
 
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingBottom: theme.spacing(2)
    },
    lockup: {
      marginRight: theme.spacing(2),
      width: '350px'
    },
    title: {
      fontWeight: 200
    },
    navButtons: {
      flexGrow: 1,
      paddingLeft: '1rem'
    },
    navButton: {
      color: 'white'
    }
  })
);

export type HdaeAppBarProps = {
  title: string,
  maxWidth: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const HdaeAppBar: React.FC<HdaeAppBarProps> = props => {
  const {signOut, user, apiToken} = useContext(UserContext);
  const classes = useStyles();

  return (
    <Box className={classes.root} displayPrint="none">
      <AppBar position="relative">
        <Container maxWidth={props.maxWidth}>
          <Toolbar disableGutters>
            <img src={UcsbHdaeLockup} className={classes.lockup} alt="Housing, Dining &amp; Auxiliary Enterprises" />

            <Box displayPrint="none" className={classes.navButtons}>
              <AuthorizedContent isAuthorized={useIsAdmin(apiToken)}>
                <Button
                  className={classes.navButton}
                  href="/admin"
                >All</Button>

                <Button
                  className={classes.navButton}
                  href="/admin/pay"
                >Pay</Button>

                <Button
                  className={classes.navButton}
                  href="/admin/approve"
                >Prepare</Button>

                <Button
                  className={classes.navButton}
                  href="/admin/program"
                >Program</Button>

                <Button
                  className={classes.navButton}
                  href="/admin/billing"
                >Billing</Button>
              </AuthorizedContent>
            </Box>

            {
              // TODO: Do I need isInitialized?
              <UserPill user={user} signOut={signOut} />
            }
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
};
export default HdaeAppBar;
